module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCondMed-Regular.281acb51.ttf";